(ns heraldicon.frontend.main
  (:require
   [clojure.string :as str]
   [heraldicon.config :as config]
   [heraldicon.frontend.auto-complete :as auto-complete]
   [heraldicon.frontend.core]
   [heraldicon.frontend.dark-mode :as dark-mode]
   [heraldicon.frontend.header :as header]
   [heraldicon.frontend.keys]
   [heraldicon.frontend.language :as language :refer [tr]]
   [heraldicon.frontend.message :as message]
   [heraldicon.frontend.modal :as modal]
   [heraldicon.frontend.router :as router]
   [heraldicon.frontend.scroll-restoration :as scroll-restoration]
   [heraldicon.frontend.search-filter :as search-filter]
   [heraldicon.frontend.state :as state]
   [heraldicon.frontend.title :as title]
   [heraldicon.frontend.tutorial :as tutorial]
   [heraldicon.frontend.user.session :as session]
   [re-frame.core :as rf]
   [re-frame.subs :as r-subs]
   [reagent.dom.client :as r]
   [taoensso.timbre :as log]))

(def ^:private login-banner-sections
  #{"arms" "charge" "collection" "ribbon"})

(defn- login-banner []
  (let [logged-in? @(rf/subscribe [::session/logged-in?])
        section (some-> (router/current-route) namespace (str/split #"[.]") second)]
    (when (and (not logged-in?)
               (login-banner-sections section))
      [:div.banner.info
       [:i.fas.fa-exclamation-circle]
       " "
       [tr :string.banner/not-logged-in]])))

(defn- flash-banner []
  (let [{:keys [type message]} @(rf/subscribe [::message/message :global])]
    (when message
      [:div.banner {:class (case type
                             :success "success"
                             :error "warning")}
       [:i.fas {:class (case type
                         :success "fa-check-circle"
                         :error "fa-exclamation-circle")}]
       " "
       [tr message]
       [:button.banner-close
        {:type "button"
         :title (tr :string.button/close)
         :on-click #(rf/dispatch [::message/clear :global])}
        [:i.fas.fa-times]]])))

(defn app []
  [:<>
   [header/view]
   [:div.main-content {:class [(dark-mode/class)
                               (when (router/app-shell?)
                                 "app-shell no-scrollbar")]}
    [login-banner]
    [flash-banner]
    [router/view]
    [modal/render]
    [auto-complete/render]]
   [tutorial/view]])

(defonce ^:dynamic *app-root*
  nil)

(defonce ^:dynamic *title-root*
  nil)

(defn app-root []
  (when *app-root*
    (r/unmount *app-root*))
  (set! *app-root* (r/create-root (.getElementById js/document "app")))
  *app-root*)

(defn title-root []
  (when *title-root*
    (r/unmount *title-root*))
  (set! *title-root* (r/create-root (first (.getElementsByTagName js/document "title"))))
  *title-root*)

(defn- get-list-id []
  (let [path js/window.location.pathname]
    ;; this hard-coded matching is not ideal, but we need to know this before the router starts its work;
    ;; maybe someday I'll find a better way, but for now this is good enough
    (case path
      "/arms/" :arms-list
      "/charges/" :charge-list
      "/collections/" :collection-list
      "/ribbons/" :ribbon-list
      nil)))

(defn- restore-search-list-from-url-parameters []
  (when-let [list-id (get-list-id)]
    (rf/dispatch-sync [::search-filter/restore-from-url-parameters list-id])))

(defonce hook-browser-navigation
  (.addEventListener js/window "popstate" restore-search-list-from-url-parameters))

(defn ^:export init []
  (log/info :release (config/get :release))
  ;; Sentry comes from its CDN bundle in index.html and the server-rendered page;
  ;; it's missing when an ad blocker blocks it
  (when-let [^js sentry (and (not= (config/get :stage) "dev")
                             (not (config/get :backend?))
                             (.-Sentry js/window))]
    (.init sentry
           (clj->js
            {:dsn "https://0723f8737fa50a0ecbae2ade37e83976@o4506989681049600.ingest.us.sentry.io/4506991066021888"
             :environment (config/get :stage)
             :release (config/get :release)
             :integrations [(.captureConsoleIntegration sentry (clj->js {:levels ["error"]}))]})))
  (r-subs/clear-subscription-cache!)
  (rf/dispatch-sync [::state/initialize])
  (rf/dispatch-sync [::language/load-setting])
  (restore-search-list-from-url-parameters)
  (session/read-from-storage)
  (scroll-restoration/start)
  (router/start)
  (r/render (app-root) [app])
  (r/render (title-root) [title/title]))
